import React from 'react'

export function UserPositioning() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g
        fill="#FFFFFF"
        fillRule="evenodd"
        clipPath="url(#clip0_3589_9266)"
        clipRule="evenodd"
      >
        <path d="M9 4.313a1.688 1.688 0 100 3.375 1.688 1.688 0 000-3.375zM6.187 6a2.813 2.813 0 115.626 0 2.813 2.813 0 01-5.626 0z" />
        <path d="M3.938 13.5a5.063 5.063 0 0110.124 0 .562.562 0 11-1.124 0 3.938 3.938 0 00-7.876 0 .562.562 0 11-1.125 0zM12.938 1.5c0-.31.251-.563.562-.563h3c.31 0 .563.252.563.563v3a.562.562 0 11-1.125 0V2.062H13.5a.562.562 0 01-.563-.562zM.938 1.5c0-.31.251-.563.562-.563h3a.563.563 0 010 1.125H2.062V4.5a.563.563 0 01-1.124 0v-3zM16.5 12.938c.31 0 .563.251.563.562v3c0 .31-.252.563-.563.563h-3a.562.562 0 110-1.125h2.438V13.5c0-.31.251-.563.562-.563zM1.5 12.938c.31 0 .563.251.563.562v2.438H4.5a.562.562 0 110 1.124h-3a.562.562 0 01-.563-.562v-3c0-.31.252-.563.563-.563z" />
      </g>
      <defs>
        <clipPath id="clip0_3589_9266">
          <path fill="#fff" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
